import React, { ReactElement } from 'react';

import { Assets } from '../../../utils/assets';
import * as S from './Profile.styles';

export type Props = {
  name: string;
  position: string | string[];
  img: {
    url: string;
    alt: string;
  };
  link?: string;
};

export const Profile = (props: Props): ReactElement => {
  const { name, position, img, link } = props;
  return (
    <S.Wrapper>
      <S.ImageWrapper>
        <S.Image alt={img.alt} src={img.url} />
        <S.ImageOverlay alt="overlay" src="https://cdn.brain.fm/images/profile_bg.webp" />
      </S.ImageWrapper>
      <S.CaptionWrapper>
        <div>
          <S.Caption>{name}</S.Caption>
          {Array.isArray(position) ? (
            <S.PositionsList>
              {position.map(p => (
                <S.SubCaption key={p}>{p}</S.SubCaption>
              ))}
            </S.PositionsList>
          ) : (
            <S.SubCaption>{position}</S.SubCaption>
          )}
        </div>
        {link && (
          <S.Link href={link} rel="no-follow" target="_blank">
            <S.LinkImage src={Assets.icons.link.url} />
          </S.Link>
        )}
      </S.CaptionWrapper>
    </S.Wrapper>
  );
};
